import http from "../../../utils/fetch";

export default {
    baseurl:'/api/swyl/v1/demo/bscUserInfoAgentAbility',

    selecPage(query) {
        return http({
            url: this.baseurl+'/selectListPage',
            method: 'post',
            params: query
        });
    },
    selectById(id){
        return http({
            url: this.baseurl+'/selectById',
            method: 'post',
            params: {id:id}
        });
    },
    selectByInstId(id){
        return http({
            url: this.baseurl+'/selectByInstId',
            method: 'post',
            params: {id:id}
        });
    },
    updateById(f){
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            params: f
        });
    },
    approvalStart(f){
        return http({
            url: this.baseurl+'/approvalStart',
            method: 'post',
            params: f
        });
    },

    approvalPass(f){
        return http({
            url: this.baseurl+'/approvalPass',
            method: 'post',
            params: f
        });
    },

    //重新提交
    resubmitAgentAbility(f){
        return http({
            url: this.baseurl+'/resubmitAgentAbility',
            method: 'post',
            params: f
        });
    },





}